const TipsSidebar = ({
    tips,
    selectedTip,
    setSelectedTip
}) => {

    return (

        <aside className="
    w-full
    bg-white
    rounded-3xl
    border
    border-gray-200
    p-4
    sm:p-6
    shadow-sm
    md:sticky
    md:top-24
">


            {/* Header */}

            <div className="mb-6">

                <h3 className="
          font-bold
          text-xl
          text-gray-900
        ">
                    Health Tips
                </h3>


                <p className="
          text-sm
          text-gray-500
          mt-1
        ">
                    Helpful healthcare advice
                </p>

            </div>



            {/* Tips List */}

            <div className="
        space-y-3
      ">

                {
                    tips.map((tip, index) => (

                        <button

                            key={tip._id}

                            onClick={() => setSelectedTip(tip)}

                            className={`
                w-full
                flex
                items-center
                gap-3
                px-3
                sm:px-4
                py-3
                sm:py-4
                rounded-2xl
                transition-all
                duration-300
                border

                ${selectedTip?._id === tip._id
                                    ?
                                    "border-green-600 bg-white text-green-600"
                                    :
                                    "border-gray-200 bg-white text-gray-800 hover:bg-green-50 hover:border-green-300"
                                }
              `}

                        >


                            <span
                                className={`
                  flex
                  items-center
                  justify-center
                  w-8
                  h-8
                  rounded-full
                  text-sm
                  font-semibold
                  flex-shrink-0

                  ${selectedTip?.id === tip.id
                                        ?
                                        "bg-green-600 text-white"
                                        :
                                        "bg-green-100 text-green-700"
                                    }
                `}
                            >
                                {index + 1}
                            </span>



                            <span className="
                text-sm
                sm:text-base
                font-medium
                text-left
                leading-tight
              ">
                                {tip.title}
                            </span>


                        </button>

                    ))
                }

            </div>


        </aside>

    );

};


export default TipsSidebar;